import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { Container, LargeHeaderTitle, theme, useResponsive } from '@sg/garnish';

import { useChallengesAndRewards } from '@order/ChallengesAndRewards';
import { useLocalizationContext } from '@order/Localization';

import { ChallengesScreenChallenges } from '../ChallengesScreenChallenges';
import { ChallengesScreenRewards } from '../ChallengesScreenRewards';

export const ChallengesScreenContentSignedIn = ({
  testID,
}: ChallengesScreenContentSignedInProps) => {
  const { t } = useLocalizationContext();
  const { fetchChallengeRewards, fetchChallenges } = useChallengesAndRewards();
  const { match } = useResponsive();

  const contentWrapperStyle = [
    styles.contentWrapper,
    match([styles.contentWrapperXS, styles.contentWrapperSM]),
  ];

  // ─────────────────────────────────────────────────────────────────

  useFocusEffect(fetchChallengeRewards);
  useFocusEffect(fetchChallenges);

  // ─────────────────────────────────────────────────────────────────

  return (
    <View testID={testID}>
      <LargeHeaderTitle>{t('challenges.signed-in.header')}</LargeHeaderTitle>

      <Container style={styles.container} wrapperStyle={contentWrapperStyle}>
        <ChallengesScreenRewards />
        <ChallengesScreenChallenges />
      </Container>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentWrapper: {
    flexGrow: 1,
  },
  contentWrapperXS: {
    paddingBottom: theme.spacing['6'],
  },
  contentWrapperSM: {
    paddingBottom: theme.spacing['10'],
  },
  container: {
    flexGrow: 1,
  },
});

// ─── TYPES ─────────────────────────────────────────────────────────────────────

type ChallengesScreenContentSignedInProps = Pick<ViewProps, 'testID'>;
